import classnames from 'classnames';

/**
 * 自定义Table单元格的Attributes
 * 主要用来实现Update Status板块列的间隔展示不同背景色、勾勾颜色
 * 多个日期的Update Status组合列板块 间隔 展示 不同的背景色、勾勾颜色，提升数据的展示的直观性
 * @param props
 * @param context
 * @return React.HTMLAttributes<HTMLTableDataCellElement> 表格单元格的HTML属性
 */
export const getTableDataCellElementAttrs = (
  props: React.HTMLAttributes<HTMLTableDataCellElement>,
  context: { recordIndex: number; columnIndex?: number },
): React.HTMLAttributes<HTMLTableDataCellElement> => {
  const { recordIndex, columnIndex = 0 } = context || {};
  if (recordIndex < 0) return props;
  if (columnIndex < 5) return props;
  /**
   * 因为前7列为固定列（Project列、Priority列、PTeam列、P-teamContact列、Finance Contact列、Update列、Finance列），所以这里要先减7，再对10取模
   * 因为Updates Status分为Detail、Milestone、Update、Finance、Stakeholder共5个子列，所以相邻的两列Updates Status共10个子列，10个子列为一组
   * 在一组子列中，前5个子列背景色为淡蓝色，勾勾为蓝色、后5个子列背景色为淡绿色，勾勾为绿色
   */
  const columnIndexTmp = (columnIndex - 5) % 12;
  return {
    ...props,
    className: classnames({
      /**
       * 余数小于5，则为前5个子列（针对10个子列一组而言）
       * 背景色为淡蓝色，勾勾为蓝色
       */
      'dbg-pipeline-change-log-change-checklist-table-cell--is-primary': columnIndexTmp < 6,
      /**
       * 余数大于等于5，且小于10，则为后5个子列（针对10个子列一组而言）
       * 背景色为淡绿色，勾勾为绿色
       */
      'dbg-pipeline-change-log-change-checklist-table-cell--is-success':
        columnIndexTmp >= 6 && columnIndexTmp < 12,
    }),
  };
};
